import React, { useState, useEffect } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { Grid, withStyles } from '@material-ui/core';

import Dashboard from '../../../layouts/Dashboard';
import GridCard from '../../../components/Grid/GridCard';

import styles from './styles';
import { homeInitQuery } from './queries';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface CardCounter {
  organisations: number;
  adminUsers: number;
  referrals: number;
}

const Home = ({ classes, history }: Props): React.ReactElement => {
  const [counter, setCounter] = useState<CardCounter>({
    organisations: 0,
    adminUsers: 0,
    referrals: 0,
  });

  const { data: homeInitData } = useQuery(homeInitQuery, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && homeInitData) {
      setCounter({
        organisations: homeInitData.organisations_aggregate.aggregate.count,
        adminUsers: homeInitData.users_admin_aggregate.aggregate.count,
        referrals: homeInitData.referrals_aggregate.aggregate.count,
      });
    }
    return () => {
      mounted = false;
    };
  }, [homeInitData]);

  const handleAction = (link: string) => {
    history.push(link);
  };

  const actions = [
    {
      title: 'Organisations',
      counter: counter.organisations,
      createLink: '/admin/organisations/create',
      viewLink: '/admin/organisations',
    },
    {
      title: 'Admin Users',
      counter: counter.adminUsers,
      createLink: '/admin/users/create',
      viewLink: '/admin/users',
    },
    {
      title: 'Referrals',
      counter: counter.referrals,
      viewLink: '/admin/referrals',
    },
    {
      title: 'Device Apps',
      viewLink: '/admin/organisations/device-apps',
    },
  ];

  return (
    <Dashboard title="Dashboard">
      <Grid container spacing={4}>
        {actions.map((action) => (
          <GridCard
            fill
            key={action.title}
            gridSize={4}
            title={action.title}
            counter={action.counter}
            editLabel="Create"
            handleEdit={action.createLink ? () => handleAction(action.createLink!) : undefined}
            handleView={() => handleAction(action.viewLink)}
          />
        ))}
      </Grid>
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(Home));
